if (!customElements.get('video-steps')) {
  class VideoStepSlider extends HTMLElement {
    constructor() {
      super();

      this.nextArrow = this.querySelector('.video-step--next');
      this.prevArrow = this.querySelector('.video-step--prev');

      const video = document.querySelector('.video-steps video');

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.initSlider(this.querySelector('.video-steps-swiper'));
        });
      }

      this.initSlider(this.querySelector('.video-steps-swiper'));

      this.slider?.on('slideChange', e => {
        const sliderIndex = e.realIndex;
        document.querySelector(`.video-step-button[data-index="${sliderIndex}"]`).click();
      });

      //this.initActiveStep();
      this.initGridHeight();
      this.initVideoPlay(video);
      this.initTimeUpdate(video);
      this.initHandleChange(video);
      this.initAutoPlay(video);
    }

    connectedCallback() {}

    initSlider(elem = this) {
      this.slider = new Swiper(elem, {
        spaceBetween: 0,
        slidesPerView: 1.1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // navigation: {
        //   prevEl: this.prevArrow,
        //   nextEl: this.nextArrow,
        // },
        breakpoints: {
          750: {
            slidesPerView: 3
          }
        }
      })
    }

    /*initActiveStep() {
      document.querySelectorAll('.video-step-button').forEach((button) => {
        button.addEventListener('click', () => {
          if(!button.classList.contains('active')) {
            let handle = button.dataset.handle;
            let target_video = document.querySelector(`.step-content-video[data-step="${handle}"]`);
            let active_video = document.querySelector('.step-content-video.active');
            let active_button = document.querySelector('.video-step-button.active');

            active_video.classList.remove('active');
            active_video.querySelector('video').pause();
            active_video.querySelector('.embed-wrapper').classList.remove('play');

            target_video.classList.add('active');

            active_button.classList.remove('active');
            button.classList.add('active');
          }
        })
      })
    }*/

    initGridHeight() {
      let prev_height = 0;
      document.querySelectorAll('.step-content-subtitle').forEach((subtitle) => {
        let height = subtitle.scrollHeight;
        if(height > prev_height) {
          prev_height = height;
          document.querySelectorAll('.step-content-subtitle').forEach((elem) => {
            elem.style.minHeight = `${height}px`;
          })
        }
      })
    }

    initVideoPlay(video) {
      if (video) {
        let playBtn = video.nextElementSibling;
        if (playBtn && playBtn.classList.contains('video-play')) {
          playBtn.addEventListener('click', () => {
            let embed = playBtn.closest('.embed-wrapper');
            embed.classList.add('play');
            video.play();
          })
        }
      }
    }

    initTimeUpdate(video) {

      let steps = document.querySelectorAll('[data-start-time]');
      steps = Array.from(steps).map((value) => {
        return {step: parseInt(value.dataset.index), index: parseInt(value.dataset.index), time: parseInt(value.dataset.startTime)};
      });
      let activeStep = null;

      if (video) {
        video.addEventListener('timeupdate', function () {
          var currentTime = video.currentTime;

          var newActiveStep = steps.find((step, index) => {
            var nextStepTime = steps[index + 1] ? steps[index + 1].time : Infinity;
            return currentTime >= step.time && currentTime < nextStepTime;
          });

          if (newActiveStep && newActiveStep.index !== (activeStep ? activeStep.index : null)) {
            activeStep = newActiveStep;

            steps.forEach((step) => {
              var button = document.querySelector(`.video-step-button[data-index="${step.index}"]`);
              if (button) {
                if (step.index == activeStep.index) {
                  button.classList.add('active');
                } else {
                  button.classList.remove('active');
                }
              }
            });
          }
        });
      }
    }

    initHandleChange(video) {
      let stepButtons = document.querySelectorAll('.video-step-count');
      if (stepButtons && video) {
        stepButtons.forEach((stepButton) => {
          stepButton.addEventListener('click', function (event) {
            let time = event.target.closest('[data-start-time]');
            if (time) {
              let embed = video.closest('.embed-wrapper');
              embed.classList.add('play');
              video.currentTime = parseInt(time.dataset.startTime);
              video.play();
            }
          })
        })
      }
    }

    initAutoPlay(video) {
      if (video) {
        let videoWrapper = video.closest('.embed-wrapper');
        if (videoWrapper && videoWrapper.dataset.autoPlay && videoWrapper.dataset.autoPlay == "true") {
          video.muted = true;
          video.play();
          videoWrapper.classList.add('play');
        }
      }
    }
  }

  customElements.define('video-steps', VideoStepSlider);
}
